// extracted by mini-css-extract-plugin
module.exports = {"container":"restrict-logout_container__jbsJ5","actions":"restrict-logout_actions__20AdP"};